<template>
  <el-menu
    default-active="1"
    :collapse="collapsed"
    router
    :default-active="$route.path"
    unique-opened
    collapse-transition>
    <el-submenu
      v-for="menu in allmenu"
      :key="menu.jurId"
      :index="menu.jurTitle"
    >
      <template slot="title">
        <i  :style="{ color: cuttrnA === menu.jurTitle ? '#ee7609' : '' }" :class="menu.jurIcon"></i>
        <span>{{ menu.jurTitle }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item
          v-for="chmenu in menu.children"
          :index="chmenu.jurUrl"
          :key="chmenu.jurId"
          @click="handleClick(menu.jurTitle,chmenu.jurTitle,chmenu.jurUrl)"
        >
          <div class="box_itme" style="display: flex;">
            <div class="" style="text-align: end; margin-left: 10px;"><span class="class_box_itme"></span></div>
            <div>{{ chmenu.jurTitle }}</div>
          </div>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { isReturn } from '@/utils/retnue'
import { getTeachers } from "@/api/fiveClassApi"
import { aD } from '@fullcalendar/core/internal-common';
export default {
  name: "LeftMenu",
  data() {
    return {
      collapsed: false,
      allmenu: [],
      setIntervalClr:null,
      cuttrnA: ''
    };
  },
  created() {},
  destroyed(){
    clearInterval(this.setIntervalClr)
  },
  mounted() {

    console.log(`%c
                                                         __----~~~~~~~~~~~------___
                                        .  .   ~~//====......          __--~ ~~
                        -.            \_|//     |||\\  ~~~~~~::::... /~
                     ___-==_       _-~o~  \/    |||  \\            _/~~-
             __---~~~.==~||\=_    -_--~/_-~|-   |\\   \\        _/~
         _-~~     .=~    |  \\-_    '-~7  /-   /  ||    \      /
       .~       .~       |   \\ -_    /  /-   /   ||      \   /
      /  ____  /         |     \\ ~-_/  /|- _/   .||       \ /
      |~~    ~~|--~~~~--_ \     ~==-/   | \~--===~~        .\
               '         ~-|      /|    |-~\~~       __--~~
                           |-~~-_/ |    |   ~\_   _-~            /\
                                /  \     \__   \/~                \__
                            _--~ _/ | .-~~____--~-/                  ~~==.
                           ((->/~   '.|||' -_|    ~~-/ ,              . _||
                                      -_     ~\      ~~---l__i__i__i--~~_/
                                      _-~-__   ~)  \--______________--~~
                                    //.-~~~-~_--~- |-------~~~~~~~~
                                           //.-~~~--\
  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

                                   大火龙🐉            永无BUG
    `,"color: red")



    this.setIntervalClr = setInterval(()=>{
        getTeachers().then(res => {
           isReturn(res.code)
        })
    },20000)

    let arr = JSON.parse(window.localStorage.getItem("jur"))
    let username = window.localStorage.getItem("username")



    this.allmenu = arr.filter((itme)=>{
      return (itme.jurTitle !== "小程序权限" && itme.jurTitle !== "组织架构" && itme.jurTitle !== "通知权限" && itme.jurTitle !== '测试菜单' && itme.jurTitle !== '城市权限' && itme.jurTitle !== '个人数据'&& itme.jurTitle !== '数据权限' && itme.jurTitle !== 'Wiki')
    })



    this.allmenu.forEach((itme)=>{
      if(itme.children){
         itme.children.forEach((itmes,index)=>{
           if(itmes.jurTitle === '审批管理员'){
              itme.children.splice(index, 1);
           }
         })
      }
    })


    this.allmenu.forEach((itme)=>{

      if(itme.jurTitle === '系统管理'){
         let isUser = true
         let isRole = true
         itme.children.forEach((itmes,index)=>{
            if (index === 4) {
                isUser = false
            }
            if (index === 5) {
                isRole = false
            }
         })
         window.sessionStorage.setItem('isUser', isUser)
         window.sessionStorage.setItem('isRole', isRole)

      }
    })



    this.allmenu.forEach((itme)=>{
      if(itme.children){
         itme.children.forEach((itmes,index)=>{
           if(itmes.jurTitle === '用户删除权限'){
              itme.children.splice(index, 1);
           }
         })
      }
    })

    this.allmenu.forEach((itme)=>{
      if(itme.children){
         itme.children.forEach((itmes,index)=>{
           if(itmes.jurTitle === '角色删除权限'){
              itme.children.splice(index, 1);
           }
         })
      }
    })


  },

  methods:{
    handleClick(a,b,c){
      this.cuttrnA = a
      this.$emit("handleClickRouter",a,b,c)
    },
  }

};
</script>
<style scoped lang="less">

.class_box_itme {
 content: "";
 background: #fff;
 display: inline-flex;
 width: 10px;
 height: 10px;
 border-radius: 50%;
 margin-right: 10px;
 margin-top: 0px;
 margin-left: 55px;
 opacity: 0;
}

.el-menu-item {
  padding-left: 0px !important;
}

.el-menu-item:hover {
  border-left: 4px solid #ce6228;
  background-color: #f1ded2;
}
/deep/ .el-submenu__title,
.el-menu-item {
  border-bottom: 1px solid #dbdedfde;
  text-align: start;
}

/deep/ .el-submenu.is-active .el-submenu__title {
  border-bottom-color: #dcdfdbde;
  color: #ee7609;
  border-left: 4px solid #ce6228;
}
/deep/ .el-menu-item-group__title {
  padding: 0px;
}

/deep/ .is-active{
  color: #ee7609;
  background-color: #f1ded2;
}



</style>



// WEBPACK FOOTER //
// src/manager/layout/menu.vue